import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getSocialMediaThemes = async ({ params } = {}) => {
  const res = await axios.middleware.get("/aluno.asmx/Temas", {
    params: { alunoid: _cookies.getItem("auth").user.alunoid },
  });
  return res[0].data;
};

export const useSocialMediaThemes = ({ config, themeId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["socialMediaThemes", { themeId }],
    queryFn: getSocialMediaThemes,
  });
};
